module.exports = __webpack_public_path__ + "static/media/YB5F07_3.0f243479.jpg";